<!--赖传峰-->
<!--2021/12/15-->
<!--eslint-disable max-len-->
<template>
  <PathSlot v-bind="props">
    <path
      :stroke="props.color"
      clip-rule="evenodd"
      d="M3 6C3 4.89543 3.89543 4 5 4H10.4375C10.7868 4 11.1107 4.18223 11.2921 4.48073L12.5079 6.48168C12.6893 6.78017 13.0132 6.96241 13.3625 6.96241H19C20.1046 6.96241 21 7.85784 21 8.96241V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18V6Z"
      fill-rule="evenodd"
      stroke-width="2"
    />
  </PathSlot>
</template>

<script lang="ts" setup>
import iconPropsType from './iconPropsType'
import PathSlot from './PathSlot.vue'

const props = defineProps(iconPropsType)
</script>
